const options = {
  5: "bg-purple-50/5",
  10: "bg-purple-50/10",
  25: "bg-purple-50/25",
  50: "bg-purple-50/50",
  75: "bg-purple-50/75",
  90: "bg-purple-50/90",
  100: "bg-purple-50",
};

const from = {
  5: "from-purple-50/5",
  10: "from-purple-50/10",
  25: "from-purple-50/25",
  50: "from-purple-50/50",
  75: "from-purple-50/75",
  90: "from-purple-50/90",
  100: "from-purple-50",
};

export default function getBackgroundPurple50(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
